<template>
	<div>
		<el-breadcrumb separator="/">
			<el-breadcrumb-item>计划管理</el-breadcrumb-item>
			<el-breadcrumb-item>工单管理</el-breadcrumb-item>
			<el-breadcrumb-item>工单导入</el-breadcrumb-item>
		</el-breadcrumb>

		<div class="form-bar">
			<el-row>
				<el-col :span="12">
					<el-form :inline="true">
						<el-form-item label="下载模板">
							<a href="file/工单导入模板.xlsx" style="margin-right:20px;">点击下载模板</a>
						</el-form-item>
						<el-form-item>
							<input type="file" ref="inputFile" @change="handleSelectFile($event)" />
						</el-form-item>
					</el-form>
				</el-col>
				<el-col :span="12" style="text-align:right;">
					<el-button type="primary" :disabled="excelData.length == 0" @click="check" :loading="checking">数据校验</el-button>
					<el-button type="primary" :disabled="!available" @click="submit" :loading="saving">导入</el-button>
					<el-button type="info" @click="$router.back()">返回</el-button>
				</el-col>
			</el-row>
		</div>

		<el-table border :data="excelData">
			<el-table-column type="index" width="60" label="行号"></el-table-column>
			<el-table-column label="工单ID">
				<template scope="scope">
					<div v-text="scope.row.work_order_id"></div>
					<small class="error" v-text="scope.row.validateInfo.work_order_id"></small>
				</template>
			</el-table-column>
			<el-table-column label="工单号" width="100">
				<template scope="scope">
					<div v-text="scope.row.work_order_code"></div>
					<small class="error" v-text="scope.row.validateInfo.work_order_code"></small>
				</template>
			</el-table-column>
			<el-table-column label="作业号" width="130">
				<template scope="scope">
					<div v-text="scope.row.code"></div>
					<small class="error" v-text="scope.row.validateInfo.code"></small>
				</template>
			</el-table-column>
			<el-table-column label="机台名称" width="100">
				<template slot-scope="scope">
					<div v-text="scope.row.jt_name"></div>
					<small class="error" v-text="scope.row.validateInfo.jt_name"></small>
				</template>
			</el-table-column>

			<el-table-column label="产品名称" width="200">
				<template slot-scope="scope">
					<div v-text="scope.row.product_name"></div>
					<small class="error" v-text="scope.row.validateInfo.product_name"></small>
				</template>
			</el-table-column>

			<el-table-column label="用户名" width="120">
				<template slot-scope="scope">
					<div v-text="scope.row.worker_name"></div>
					<small class="error" v-text="scope.row.validateInfo.worker_name"></small>
				</template>
			</el-table-column>
			<el-table-column label="计划开始时间" width="110">
				<template slot-scope="scope">
					<div v-text="scope.row.plan_begin_time"></div>
					<small class="error" v-text="scope.row.validateInfo.plan_begin_time"></small>
				</template>
			</el-table-column>
			<el-table-column label="计划结束时间" width="110">
				<template slot-scope="scope">
					<div v-text="scope.row.plan_end_time"></div>
					<small class="error" v-text="scope.row.validateInfo.plan_end_time"></small>
				</template>
			</el-table-column>
			<el-table-column label="托盘数" width="100">
				<template slot-scope="scope">
					<div v-text="scope.row.plates"></div>
					<small class="error" v-text="scope.row.validateInfo.plates"></small>
				</template>
			</el-table-column>

			<el-table-column label="准备时间" width="100">
				<template slot-scope="scope">
					<div v-text="scope.row.pre_time"></div>
					<small class="error" v-text="scope.row.validateInfo.pre_time"></small>
				</template>
			</el-table-column>

			<el-table-column label="状态" width="80">
				<template slot-scope="scope">
					<div v-text="scope.row.status"></div>
					<small class="error" v-text="scope.row.validateInfo.status"></small>
				</template>
			</el-table-column>

			<el-table-column label="总长度" width="80">
				<template slot-scope="scope">
					<div v-text="scope.row.total_len"></div>
					<small class="error" v-text="scope.row.validateInfo.total_len"></small>
				</template>
			</el-table-column>

			<el-table-column label="总卷数" width="80">
				<template slot-scope="scope">
					<div v-text="scope.row.roll_num"></div>
					<small class="error" v-text="scope.row.validateInfo.roll_num"></small>
				</template>
			</el-table-column>

			<el-table-column label="每卷长度" width="100">
				<template slot-scope="scope">
					<div v-text="scope.row.roll_len"></div>
					<small class="error" v-text="scope.row.validateInfo.roll_len"></small>
				</template>
			</el-table-column>

			<el-table-column label="工序索引" width="200">
				<template slot-scope="scope">
					<div v-text="scope.row.process_index"></div>
					<small class="error" v-text="scope.row.validateInfo.process_index"></small>
				</template>
			</el-table-column>

			<el-table-column label="校验结果" width="180">
				<template slot-scope="scope">
					<div :class="{ result: true, error: scope.row.hasError, success: scope.row.isValid }" v-text="scope.row.message"></div>
				</template>
			</el-table-column>
			<el-table-column label="操作" width="80">
				<template slot-scope="scope">
					<el-button type="text" @click="remove(scope.$index)" icon="el-icon-delete"></el-button>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
	import { JobOrderImport } from '@/components/JobOrder'
	export default {
		data() {
			return {
				pi: {},
				excelData: [],
				available: false,
				saving: false,
				checking: false,
			}
		},
		watch: {},
		methods: {
			handleSelectFile() {
				console.log('handleSelectFile1', event)
				if (!event.target.files) {
					return
				}

				var self = this
				var f = event.target.files[0]

				this.pi = new JobOrderImport(f, data => {
					console.log('导入完成', data)

					this.excelData = data
				})

				this.$refs.inputFile.value = ''
			},
			/**
			 * 进行数据校验。
			 */
			async check() {
				this.checking = true
				for (let i = 0; i < this.excelData.length; i++) {
					const t = this.excelData[i]
					this.excelData[i] = await this.pi.validate(t)
				}

				if (this.excelData.length > 0 && this.excelData.filter(t => t.hasError) == 0) {
					this.available = true
				}

				this.checking = false
			},
			/**
			 * 导入
			 */
			submit() {
				if (this.saving) {
					return
				} else {
					this.saving = true
				}

				this.pi
					.save()
					.then(res => {
						if (res.data.inserted == this.excelData.length) {
							this.$alert(`全部数据导入成功，数据量：${this.excelData.length}<br/>点击确定返回工单列表`, '提示', {
								dangerouslyUseHTMLString: true,
								confirmButtonText: '确定',
								callback: action => {
									this.$router.back()
								},
							})
						} else {
							console.log('导入成功：', res.data.inserted)
						}
					})
					.finally(() => {
						this.saving = false
					})
			},
			/**
			 * 删除记录
			 */
			remove(index) {
				this.pi.deleteRow(index)

				if (this.excelData.length > 0 && this.excelData.filter(t => t.hasError) == 0) {
					this.available = true
				}
			},
		},
	}
</script>

<style lang="less" scoped>
	.empty {
		height: 300px;
	}

	.result {
		color: #000;
	}

	.error {
		color: #ce0000;
	}

	.result.success {
		color: #00b75a;
	}
</style>
